<template>
  <section>
    <b-row>
      <h4>{{ $t("match-raw-title") }}</h4>
    </b-row>
    <b-row>
      <pre>{{ match }}</pre>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "components-match-raw",
  computed: {
    ...mapGetters({ match: "users/getSelfMatch" })
  }
};
</script>
